<template>
  <modal :title="title" :active.sync="active" :classModal="'modal-xl'">
    <div slot="header">
      <div class="vx-row flex text-primar justify-center m-2">
        <h3 class="text-primary">Detail Permohonan</h3>
      </div>
    </div>
    <div class="vx-row m-0" v-if="permohonan">
      <div class="flex flex-col w-full justify-center px-5">
        <div class="w-full text-center  font-medium text-xl my-5 mb-0">
          Berikut merupakan detail permohonan dengan No. Pendaftaran <strong>{{permohonan.no_pendaftaran}}</strong>
          <vs-divider></vs-divider>
        </div>
        <div class="w-full">
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-user" />
            </div>
            <div class="flex-1"><strong>Nama Pemohon</strong> <br> {{permohonan.nama_pemohon}}</div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-calendar" />
            </div>
            <div class="flex-1"><strong>Tanggal Daftar</strong> <br> {{permohonan.tgl_daftar}}</div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-map-pin" />
            </div>
            <div class="flex-1"><strong>Lokasi Permohonan</strong> <br> Kel. {{permohonan.nama_kelurahan}}, Kec. {{permohonan.nama_kecamatan}}</div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-file-text" />
            </div>
           <div class="flex-1"><strong>Jenis Izin</strong> <br> {{permohonan.nama_izin}} ({{permohonan.nama_peruntukan}})</div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-initial pr-3">
              <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-edit" />
            </div>
            <div class="flex-1"><strong>Posisi Berkas</strong> <br> {{permohonan.nama_posisi}}</div>
          </div>
        </div>
      </div>
    </div>
    <vs-divider></vs-divider>
    <div class="flex flex-col md:flex-row md:justify-end px-3 w-full">
      <vs-button class="w-full md:w-auto mb-3 font-bold md:mr-3d" color="dark" type="flat" @click="active = false">Close</vs-button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/global/modal/Modal.vue';
export default {
  components : {
    Modal
  },
  props: {
    active: {
      type: Boolean,
      required: true,
      default : false
    },
    title:  {
      type: String,
      required: false,
      default : ''
    },
    permohonan: {
      required : false,
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  watch : {
    active : function(){
      this.$emit('update:active', this.active)
    }
  }
}
</script>